<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Theme and Skills">
      <v-card flat class="px-2"> </v-card>
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <v-card-text
          class="pt-0 pr-1"
          :class="{
            'd-block py-3': $vuetify.breakpoint.xs,
            'd-flex align-center': $vuetify.breakpoint.smAndUp
          }"
        >
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
            :class="{
              'mr-0': $vuetify.breakpoint.xs,
              'mr-5': $vuetify.breakpoint.smAndUp
            }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search By Theme Name"
            hide-details
            single-line
            style="max-width: 350px"
          />
          <v-btn
            class="mr-3"
            elevation="1"
            color="success"
            @click="getThemeList()"
          >
            <v-icon left>mdi-magnify</v-icon>Search
          </v-btn>
          <v-btn
            v-on:click="
              () => {
                $router.push({ name: 'addThemeAndSkills' })
              }
            "
            elevation="1"
            :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="accent"
          >
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </v-card-text>
        <v-divider class="my-0" />
        <v-data-table
          :headers="headers"
          :items="themeList"
          disable-pagination
          hide-default-footer
          item-key="srno"
        >
          <template v-slot:item.skillName="{ item }">
            <span>{{ item.skillName }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <router-link
              :to="{
                name: 'editThemeAndSkills',
                params: { themeAndSkillId: item.id }
              }"
            >
              <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
            </router-link>
            <v-btn
              class="px-2 ml-1 ma-1"
              color="error"
              min-width="0"
              small
              @click.prevent="deleteTheme(item)"
            >
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center"
              >No Data Available</v-card-subtitle
            >
          </template>
        </v-data-table>
        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select
              v-model="pageSize"
              :items="pageSizes"
              label="Items per Page"
              @change="handlePageSizeChange"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination
              v-model="page"
              :length="totalPages"
              :total-visible="totalPages"
              @input="handlePageChange"
            >
            </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      themeList: [],
      search: '',
      headers: [
        { text: 'Sr No', value: 'srno', align: 'center', sortable: true },
        { text: 'Theme Name', value: 'name', sortable: true },
        { text: 'Skills', value: 'skillName', align: 'center' },
        { text: 'Action', value: 'actions', sortable: false }
      ],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0
    }
  },
  created: async function () {
    await this.getThemeList()
  },
  watch: {},
  methods: {
    getThemeList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/getall-themes`,
          {
            params: {
              page: this.page - 1,
              size: this.pageSize,
              search: this.search
            }
          }
        )
        this.themeList = res.data.rows.map((item, index) => {
          item.srno = this.pageSize * (this.page - 1) + index + 1
          item.skillName = item.Skills.map((s) => s.name).join(', ') || '-'
          return item
        })
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteTheme (item) {
      this.$buefy.dialog.confirm({
        type: 'is-danger',
        title: 'Alert',
        hasIcon: true,
        message: `Are you sure to delete this theme ?`,
        onConfirm: async () => {
          try {
            await http.put(
              `${CONSTANTS.API_URL}/api/curriculum_cms/inactive-themes/${item.id}`
            )
            this.okMsg('Theme deleted successfully!')
            this.getThemeList()
          } catch (e) {
            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            return this.errMsg(errorMessage)
          }
        }
      })
    },

    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getThemeList()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getThemeList()
    }
  }
}
</script>
